import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAdmin } from '../../contexts/AdminContext';

/**
 * DepartureTopStrip — shared top strip used across the Departure Board reskin
 * of the Ixora Feedback Dashboard. Mirrors the markup in Homescreen.jsx /
 * Dashboard.jsx and routes the `.on` highlight off the current pathname.
 *
 * Pure presentational: takes no data, runs its own clock.
 */
const routeKey = (pathname) => {
  if (pathname === '/' || pathname === '' || pathname === '/dashboard') return 'dashboard';
  if (pathname.startsWith('/dashboard/feedback')) return 'feedback';
  if (
    pathname.startsWith('/dashboard/supervisor-information') ||
    pathname.startsWith('/dashboard/manage-supervisors') ||
    pathname.startsWith('/supervisors')
  ) return 'supervisors';
  if (pathname.startsWith('/admin/site-managers')) return 'sitemanagers';
  if (pathname.startsWith('/site-view')) return 'siteview';
  if (
    pathname.startsWith('/fame') ||
    pathname.startsWith('/sms-blast') ||
    pathname.startsWith('/gps-tracking')
  ) return 'other';
  return '';
};

export default function DepartureTopStrip() {
  const { pathname } = useLocation();
  const { isAdmin, isSiteManager, signOut } = useAdmin();
  const active = routeKey(pathname);
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const timeStr = now.toLocaleTimeString('en-GB', { hour12: false });
  const dateStr = now.toLocaleDateString('en-GB', {
    weekday: 'short', day: '2-digit', month: 'short', year: 'numeric',
  }).toUpperCase();
  return (
    <header className="db-top">
      <div className="db-brand">
        <img src="/ixora_logo_clean.png" alt="Ixora Group" className="db-brand-logo" />
        <span className="sep">·</span><span className="product">FEEDBACK</span>
      </div>
      <nav className="db-nav">
        {!isSiteManager && <Link to="/" className={active === 'dashboard' ? 'on' : ''}>DASHBOARD</Link>}
        {isAdmin && <Link to="/dashboard/feedback" className={active === 'feedback' ? 'on' : ''}>FEEDBACK</Link>}
        {isAdmin && <Link to="/dashboard/supervisor-information" className={active === 'supervisors' ? 'on' : ''}>SUPERVISORS</Link>}
        {isAdmin && <Link to="/admin/site-managers" className={active === 'sitemanagers' ? 'on' : ''}>SITE MANAGERS</Link>}
        {isAdmin && <Link to="/fame" className={`other${active === 'other' ? ' on' : ''}`}>OTHER APPS ↓</Link>}
        {!isAdmin && isSiteManager && (
          <Link to="/site-view" className={active === 'siteview' ? 'on' : ''}>YOUR SITE</Link>
        )}
        {!isAdmin && isSiteManager && (
          <button
            type="button"
            onClick={signOut}
            style={{
              background: 'none',
              border: 'none',
              fontFamily: 'inherit',
              fontSize: 'inherit',
              letterSpacing: 'inherit',
              color: 'var(--c-ink-3)',
              cursor: 'pointer',
              padding: 0,
              transition: 'color 120ms ease',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--c-ink)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--c-ink-3)'; }}
          >
            SIGN OUT
          </button>
        )}
      </nav>
      <div className="db-clock">{timeStr}<span className="grey">· {dateStr} · IST</span></div>
    </header>
  );
}
